module.exports = "<button type=\"button\" class=\"btn btn-primary\" (click)=\"speakerSrv.changeView('RES', $event)\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i>\n    Back</button>\n<br/><br/>\n<div style=\"display: block\">\n    <canvas #bar baseChart\n            [datasets]=\"plotData\"\n            [labels]=\"corpus\"\n            [options]=\"options\"\n            chartType=\"bar\"\n            [colors]=\"barColors\"\n            (chartClick)=\"chartClicked($event)\">\n    </canvas>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/src/app/change/change.component.html
// module id = ../../../../../src/app/change/change.component.html
// module chunks = 0